<template>
  <div :class="divClass">
    <strong>{{label}}{{ showDoubleDot ? ':' : '' }} </strong><span>{{value || withoutInformation}}</span>
  </div>
</template>

<script>
export default {
  name: "LabelDetails",

  props: {
    label: {type: String, default: ''},
    value: {type: String, default: ''},
    showDoubleDot: {type: Boolean, default: true},
    divClass: {type: String, default: 'p-col-12 p-md-6 p-lg-4'},
  },

  data(){
    return {
      withoutInformation: this.$t('not.information'),
    }
  }

}
</script>

<style scoped>

</style>